<template>
  <div v-if="rsvp?.mode === 'closed'" class="c-guests-delete">
    <a @click.prevent="$refs.modalConfirmDeleteInvite.open()">
      <button>
        <base-icon name="painel/trash-icon" width="24" height="25" />
      </button>
    </a>
    <GuestsDeleteInvite :rsvp="rsvp" ref="modalConfirmDeleteInvite" />
  </div>
  <div v-else class="c-guests-delete" v-click-outside="closeDelete">
    <a @click="toggleDelete">
      <button>
        <base-icon name="painel/trash-icon" width="24" height="25" />
      </button>
    </a>
    <transition>
      <ul v-if="toggleListDelete" class="c-guests-delete__list">
        <li v-if="rsvp.guests.length > 1">
          <a @click="deleteGuest">Excluir apenas um convidado</a>
        </li>
        <li>
          <a @click="deleteRsvp">Excluir esta confirmação inteira</a>
        </li>
      </ul>
    </transition>
    <GuestsDeleteGuest
      v-if="rsvp.guests.length > 1"
      :guests="rsvp.guests"
      ref="modalDeleteGuest"
    />
    <GuestsDeleteRsvp :rsvp="rsvp" ref="modalDeleteRsvp" />
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import GuestsDeleteGuest from '@/components/Rsvp/GuestsDeleteGuest.vue'
import GuestsDeleteRsvp from '@/components/Rsvp/GuestsDeleteRsvp.vue'
import GuestsDeleteInvite from '@/components/Rsvp/GuestsDeleteInvite.vue'
import ModalActionConfirmation from '@/components/Shared/ModalActionConfirmation.vue'

export default {
  props: {
    rsvp: {
      type: Object,
    },
  },

  components: {
    GuestsDeleteGuest,
    GuestsDeleteRsvp,
    GuestsDeleteInvite,
  },

  directives: {
    ClickOutside,
  },

  data() {
    return {
      toggleListDelete: false,
    }
  },

  methods: {
    deleteGuest() {
      this.$refs.modalDeleteGuest.open()
      this.toggleListDelete = false
    },

    deleteRsvp() {
      this.$refs.modalDeleteRsvp.open()
      this.toggleListDelete = false
    },

    closeDelete() {
      this.toggleListDelete = false
    },

    toggleDelete() {
      if (this.rsvp.guests.length > 1)
        this.toggleListDelete = !this.toggleListDelete
      else this.deleteRsvp()
    },
  },
}
</script>

<style lang="scss">
.c-guests-delete {
  position: relative;

  a {
    button {
      color: $neutral !important;
      height: 25px;
      border-radius: 8px;
      border: 1px solid #d9e2eb;
      background: $neutrallightest;
      display: inline-flex;
      width: 48px;
      height: 48px;
      cursor: pointer;
      padding: 8px;
      justify-content: center;
      align-items: center;
      color: $neutral;
      &:hover {
        border: 1px solid $neutrallight;
        background: #d9e2eb;
      }
    }
  }
  &__list {
    @include position(absolute, 30px, 12px, auto, auto);
    @include app-shadow();
    width: 240px;
    text-align: left;
    z-index: 1;
    background-color: $white;

    li > a {
      display: block;
      padding: 0.7em 1.5em;
      color: $gray-7;
      &:hover,
      &:focus {
        background-color: rgba($supportlight, 0.4);
      }
    }
  }
}
</style>
